import { css } from '@emotion/react';
import React, { useContext, useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import t from 'react-translate';
import { LiveEventRegistrationLimit } from 'redux/schemas/models/live-event';
import NvCheckbox from 'shared/components/inputs/nv-checkbox';
import NvTextInput from 'shared/components/inputs/nv-text-input';
import { largeSpacing, tripleSpacing } from 'styles/global_defaults/scaffolding';
import { LiveSessionFormContext } from './live-session-form';

const styles = css`
  .bs4-input-group, .bs4-form-control {
    height: ${largeSpacing}px;
    width: ${tripleSpacing}px;
  }
`;

const RegistrationLimit: React.FC = () => {
  const ref = useRef<HTMLInputElement | null>(null);
  const { sessionType } = useContext(LiveSessionFormContext);
  const { watch, setValue } = useFormContext();

  const sessions = watch('sessions') ?? [];
  const isHidden = sessions.length <= 1;

  useEffect(() => {
    if (isHidden) {
      setValue('isRegistrationLimitEnabled', false);
    }
  }, [isHidden, setValue]);

  if (isHidden) {
    return null;
  }

  const isRegistrationLimitEnabled = watch?.('isRegistrationLimitEnabled');
  const defaultLabel = t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.LIMIT.DISABLED();
  const enabledLabel = t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.LIMIT.ENABLED('INPUT');
  const [prefix, suffix] = enabledLabel.split('INPUT');


  const onCheckboxToggle = (e) => {
    if (e.target?.checked && ref) {
      setTimeout(() => {
        ref.current.focus();
      });
    }
  };

  return (
    <div className={`d-flex align-items-center mt-4 p-2 ${isRegistrationLimitEnabled ? 'bg-info' : 'bg-gray-7'}`}>
      <NvCheckbox
        withForm
        name='isRegistrationLimitEnabled'
        label={!isRegistrationLimitEnabled && defaultLabel}
        onChange={onCheckboxToggle}
        labelClassName='text-regular'
      />
      {isRegistrationLimitEnabled && (
        <div
          className='d-flex align-items-center'
          css={styles}
        >
          {prefix}
          <NvTextInput
            withForm
            type='number'
            autoComplete='off'
            name='registrationLimit'
            className='mx-2'
            ref={ref}
            max={LiveEventRegistrationLimit[sessionType]}
          />
          {suffix}
        </div>
      )}
    </div>
  );
};

export default RegistrationLimit;
